var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AddressInfo',{staticClass:"ship-from",attrs:{"field":"fromAddress","item":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }